module.exports = __webpack_public_path__ + "img/cloth_g1_sleeve_14.4665f8e1.svg";